import React, { useEffect, useRef, useState } from "react";

export function CustomDateDropdown(props) {
  const { options, value, onChange, disabled, "aria-label": ariaLabel } = props;

  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const selectedItemRef = useRef(null);

  const selectedOption = options?.find(
    (opt) => String(opt.value) === String(value)
  );

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔑 AUTO-SCROLL when dropdown opens
  useEffect(() => {
    if (open && selectedItemRef.current && listRef.current) {
      selectedItemRef.current.scrollIntoView({
        block: "nearest",
      });
    }
  }, [open]);

  const handleSelect = (newValue) => {
    if (!onChange) return;

    onChange({
      target: { value: newValue },
    });

    setOpen(false);
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative", minWidth: 90 }}>
      {/* Trigger */}
      <button
        type="button"
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={() => setOpen((v) => !v)}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: 6,
          padding: "4px 8px",
          background: "#fff",
          fontSize: 14,
        }}
      >
        {selectedOption?.label}
        <span style={{ fontSize: 10, marginLeft: 10 }}>▼</span>
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 9999,
            marginTop: 4,
            width: "100%",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 6,
            boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          }}
        >
          {/* Scroll container */}
          <div
            ref={listRef}
            style={{
              maxHeight: 160, // fixed height
              overflowY: "auto",
            }}
          >
            {options?.map((option) => {
              const isSelected = String(option.value) === String(value);

              return (
                <div
                  key={option.value}
                  ref={isSelected ? selectedItemRef : null} // 🔑
                  onClick={() =>
                    !option.disabled && handleSelect(option.value.toString())
                  }
                  style={{
                    padding: "6px 10px",
                    cursor: option.disabled ? "not-allowed" : "pointer",
                    background: isSelected ? "#4f46e5" : "transparent",
                    color: isSelected ? "#fff" : "#000",
                    opacity: option.disabled ? 0.5 : 1,
                    fontSize: 14,
                    fontWeight: 600,
                  }}
                >
                  {option.label}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
